import React, { useState, useEffect } from "react";
import "../DSInfoContainer.css";
import {
  handleInputChange,
  handleSearchWattList,
  handleUpdateModule,
  handleUpdateValue,
} from "../DSFunction";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { updateQuantityInfo } from "../../../../Features/quantityInfo";
import { panelInformation } from "../../../DataFiles/panelInformation";
import ModulePreview from "../modulePreview";

export default function PVModuleOption({ emptyValues, handleKeyPress }) {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];
  const [moduleWattList, setModuleWattList] = useState([]);
  const [showList, setShowList] = useState(false);
  const [showModuleList, setShowModuleList] = useState(false);
  const [tooltip, setTooltip] = useState();

  const [preview, setPreview] = useState(false);
  const handleClose = () => {
    setPreview(false);
  };
  useEffect(() => {
    dispatch(updateQuantityInfo({ allRoof: false }));
    const getList = async () => {
      const module = roofDetail.module ? roofDetail.module : "Select";
      handleSearchWattList(module, setModuleWattList);
    };
    getList();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {roofDetail.roofType !== "Carport" && (
        <div className="formWithLabel">
          <label>Roof Height ({gridInfo.unit})</label>
          <input
            type="text"
            placeholder="Building Height"
            name="buildingHeight"
            value={roofDetail.buildingHeight}
            onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
            onKeyPress={(e) => handleKeyPress(e)}
            style={
              !(roofDetail.buildingHeight >= 0) && emptyValues
                ? { border: "3px solid red" }
                : {}
            }
          ></input>
        </div>
      )}
      {roofDetail.roofType === "Shed Roof" && (
        <div className="formWithLabel">
          <label>Roof Pitch (0)</label>
          <input
            type="text"
            name="buildingPitch"
            placeholder="Building Pitch"
            value={roofDetail.buildingPitch}
            onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
            onKeyPress={(e) => handleKeyPress(e)}
            style={
              !(roofDetail.buildingPitch >= 0) && emptyValues
                ? { border: "3px solid red" }
                : {}
            }
          ></input>
        </div>
      )}
      <div className="formWithLabel">
        <label>PV Module</label>
        <div
          className="selectOption"
          onMouseLeave={() => setShowModuleList(false)}
        >
          <ul
            id="first"
            name="module"
            value={roofDetail.module}
            onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
            style={
              roofInfo.value.module === "Select" && emptyValues
                ? { border: "2px solid red" }
                : {}
            }
          >
            <li onClick={() => setShowModuleList(!showModuleList)}>
              {roofDetail.module === "Select" ? "Select" : roofDetail.module}
              <i className="bi bi-chevron-down"></i>
            </li>
            {showModuleList && (
              <div
                className="dropDown"
                onMouseLeave={() => setShowModuleList(false)}
              >
                {panelInformation &&
                  panelInformation.map((module, index) => (
                    <li
                      key={index}
                      onClick={() =>
                        handleUpdateModule(
                          module.brand,
                          setShowModuleList,
                          dispatch,
                          setModuleWattList,
                          roofIndex
                        )
                      }
                      style={
                        roofDetail.module === module.brand
                          ? { backgroundColor: "blue", color: "white" }
                          : {}
                      }
                    >
                      {module.brand}
                    </li>
                  ))}
              </div>
            )}
          </ul>
        </div>
      </div>
      <div className="formWithLabel">
        <div className="label">
          <label>PV Module Type</label>
          {roofDetail.moduleType !== "Select" && (
            <h6
              onClick={() => setPreview(true)}
              onMouseEnter={() => setTooltip("preview")}
              onMouseLeave={() => setTooltip()}
            >
              {tooltip === "preview" && (
                <span className="warning">
                  <div className="sideArrow"></div>
                  Preview Panel Datasheet
                </span>
              )}
              <i className="bi bi-eye-fill"></i>
              <span>Preview</span>
            </h6>
          )}
        </div>
        <div className="selectOption" onMouseLeave={() => setShowList(false)}>
          <ul
            id="second"
            name="moduleType"
            value={roofDetail.moduleType}
            onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
            style={
              roofDetail.moduleType === "Select" && emptyValues
                ? { border: "2px solid red" }
                : {}
            }
          >
            <li onClick={() => setShowList(!showList)}>
              {roofDetail.moduleType === "Select"
                ? "Select"
                : roofDetail.moduleType}
              <i className="bi bi-chevron-down"></i>
            </li>
            {showList && (
              <div className="dropDown" onMouseLeave={() => setShowList(false)}>
                {moduleWattList &&
                  moduleWattList.map((item, index) => (
                    <li
                      key={index}
                      onClick={() =>
                        handleUpdateValue(
                          item,
                          setShowList,
                          dispatch,
                          roofIndex,
                          roofDetail
                        )
                      }
                      style={
                        roofDetail.moduleType === item.name
                          ? { backgroundColor: "blue", color: "white" }
                          : {}
                      }
                    >
                      {item.name}
                    </li>
                  ))}
              </div>
            )}
          </ul>
        </div>
        {roofDetail.roofType !== "Shed Roof" && (
          <div className="formShedInfo" style={{ width: "100%" }}>
            <label>Tilt Angle(°)</label>
            <input
              type="text"
              placeholder="tiltAngle"
              name="tiltAngle"
              value={roofDetail.tiltAngle}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
        )}
      </div>

      {/* Module Data Sheet  */}
      <Modal
        show={preview}
        onHide={handleClose}
        keyboard={false}
        centered
        className="datasheetModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Module Datasheet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModulePreview roofDetail={roofDetail}></ModulePreview>
        </Modal.Body>
      </Modal>
    </>
  );
}
